import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
{
    id: "po-04-h2v2-01",
    name: "PO 01 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 13, y: 285, width: 180, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 199, y: 285, width: 405, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 285, width: 405, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1026, y: 285, width: 180, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-02",
    name: "PO 02 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 106, y: 114, width: 397, height: 624, rotation: 0, imageRotation: 0 },
            { id: "2", x: 645, y: 114, width: 534, height: 346, rotation: 0, imageRotation: 0 },
            { id: "3", x: 645, y: 467, width: 173, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 825, y: 467, width: 354, height: 270, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-03",
    name: "PO 03 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 687, y: 160, width: 449, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 687, y: 460, width: 145, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 840, y: 460, width: 297, height: 232, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-04",
    name: "PO 04 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 38, y: 216, width: 265, height: 418, rotation: 0, imageRotation: 0 },
        { id: "2", x: 311, y: 216, width: 265, height: 418, rotation: 0, imageRotation: 0 },
        { id: "3", x: 713, y: 143, width: 399, height: 279, rotation: 0, imageRotation: 0 },
        { id: "4", x: 713, y: 430, width: 399, height: 278, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-05",
    name: "PO 05 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 285, width: 417, height: 284, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 425, y: 285, width: 179, height: 284, rotation: 0, imageRotation: 0 },
        { id: "3", x: 612, y: 285, width: 179, height: 284, rotation: 0, imageRotation: 0 },
        { id: "4", x: 799, y: 285, width: 417, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-06",
    name: "PO 06 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 80, y: 180, width: 697, height: 492, rotation: 0, imageRotation: 0 },
        { id: "2", x: 785, y: 180, width: 349, height: 242, rotation: 0, imageRotation: 0 },
        { id: "3", x: 785, y: 430, width: 171, height: 242, rotation: 0, imageRotation: 0 },
        { id: "4", x: 964, y: 430, width: 170, height: 242, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-07",
    name: "PO 07 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 75, y: 162, width: 333, height: 527, rotation: 0, imageRotation: 0 },
        { id: "2", x: 808, y: 162, width: 333, height: 527, rotation: 0, imageRotation: 0 },
        { id: "3", x: 416, y: 162, width: 384, height: 260, rotation: 0, imageRotation: 0 },
        { id: "4", x: 416, y: 430, width: 384, height: 259, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-08",
    name: "PO 08 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 86, y: 168, width: 326, height: 516, rotation: 0, imageRotation: 0 },
        { id: "2", x: 420, y: 168, width: 326, height: 516, rotation: 0, imageRotation: 0 },
        { id: "3", x: 754, y: 168, width: 376, height: 254, rotation: 0, imageRotation: 0 },
        { id: "4", x: 754, y: 430, width: 376, height: 254, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-09",
    name: "PO 09 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 263, y: 94, width: 473, height: 328, rotation: 0, imageRotation: 0 },
        { id: "2", x: 744, y: 94, width: 211, height: 328, rotation: 0, imageRotation: 0 },
        { id: "3", x: 263, y: 430, width: 211, height: 328, rotation: 0, imageRotation: 0 },
        { id: "4", x: 482, y: 430, width: 473, height: 328, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-10",
    name: "PO 10 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 59, y: 165, width: 362, height: 256, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 59, y: 429, width: 177, height: 255, rotation: 0, imageRotation: 0 },
        { id: "3", x: 244, y: 429, width: 177, height: 255, rotation: 0, imageRotation: 0 },
        { id: "4", x: 429, y: 165, width: 729, height: 519, rotation: 0, imageRotation: 0 }
    ],
}
];